export default __webpack_public_path__ + "static/media/email.074b0408.svg";